<template>
  <div>
    <div class="m15 container">
      <div class="container m15">
        <!-- 面包屑 -->
        <div class="integralBreadcrumb">
          <div class="integralBreadcrumb-item">
            <router-link :to="{name: 'home'}">{{$t('header.homepage')}}</router-link>
          </div>
          <div class="el-icon-arrow-right jt"></div>
          <div>{{$t('home.hotsale')}}</div>
        </div>
      </div>
      <div class="item-class-show">
        <el-row class="item-class-group"
                v-if="bestSellersTypes.length">
          <el-col class="item-class-name"
                  :span="3">{{$t('product.hotSaleCategory')}}: </el-col>
          <el-col class="item-class-select"
                  :span="20">
            <div v-for="(item, subIndex) in bestSellersTypes"
                 :key="subIndex"
                 :title="item.name"
                 :style="subIndex===choosedIndex?'color: #333;border: 1px #1d65a8 solid':''">
              <span class="item-class-spandx"
                    @click="(e)=>choose(e, 0, subIndex)"
                    v-show="choosedIndex===-1||subIndex===choosedIndex">
                {{ item.name }}
                <i class="el-icon-close iconstyle"
                   style="float:right;"
                   v-show="subIndex===choosedIndex"
                   @click="clear(subIndex)"></i>
              </span>
            </div>
          </el-col>
          <el-col class="actions"
                  :span="1">
            <el-tag type="info"
                    v-if="bestSellersTypes.length>7 && choosedIndex === -1">
              <span @click="e => show(0, e)">{{$t('common.open')}}</span>
            </el-tag>
          </el-col>
        </el-row>
      </div>
      <div style="margin-top:20px"
           v-if="showGoodlist.length">
        <goods-list :goodsList="showGoodlist"></goods-list>
      </div>
      <div v-else
           style="text-align:center;margin-top:15px">
        <img src="@/assets/img/good/noGood.png"
             alt="暂无数据">
      </div>
    </div>
  </div>
</template>

<script>
import GoodsList from '@/views/modules/activity/goodList'
export default {
  name: 'list',
  data () {
    return {
      bestSellersTypes: [],
      imgSrc: '@/assets/img/good/noGood.png',
      choosedIndex: -1,
      showGoodlist: [],
      allGoodsList: [],
      typeId: '',
      page: 1,
      limit: 24,
      count: 0,
      pageCount: 0,
      scroll: true,
      lodding: true
    }
  },
  computed: {
    choosedId () {
      return this.$route.query.id
    }
  },
  watch: {},
  methods: {
    init () {
      this.$nextTick(() => {
        this.getBestKindList()
      })
    },
    getScroll (event) {
      let scrollBottom =
        event.target.scrollHeight -
        event.target.scrollTop -
        event.target.clientHeight
      // if (this.finished && scrollBottom < 40) {
      //  操作
      // }
      console.log(scrollBottom)
    },
    // 获取热卖类目
    getBestKindList () {
      this.$request.get(`/front/user/home/homeBestSellers/listTypes`)
        .then(data => {
          console.log(data)
          this.bestSellersTypes = data.homeBestSellersTypeVos
          if (this.$route.query.id) {
            for (let i = 0; i < this.bestSellersTypes.length; i++) {
              if (this.bestSellersTypes[i].bestSellersTypeId === this.$route.query.id) {
                this.typeId = this.$route.query.id
                this.choosedIndex = i
                this.getBestSellersType()
              }
            }
          } else {
            this.getBestSellersType()
          }
        })
    },
    // 获取热卖商品
    getBestSellersType () {
      let _this = this
      this.lodding = false
      this.$store.commit('setLoadStatus', true)
      this.$request
        .postParam(`/front/user/home/homeBestSellers/list`, {
          typeId: this.typeId,
          page: this.page,
          limit: this.limit
        })
        .then((data) => {
          console.log(data)
          let list = data.data
          let showList = []
          this.count = Number(data.count)
          this.pageCount = this.pageCount + list.length
          if (this.pageCount >= this.count) {
            this.scroll = false
          } else {
            this.scroll = true
          }
          // for (let i = 0; i < list.length; i++) {
          //   showList.push({
          //     spuName: list[i].commoditySpuVo ? list[i].commoditySpuVo.name : '',
          //     activityPrice: list[i].commoditySpuVo ? list[i].commoditySpuVo.minPrice : '',
          //     minPrice: list[i].commoditySpuVo ? list[i].commoditySpuVo.minPrice : '',
          //     sellingPrice: list[i].commoditySpuVo ? list[i].commoditySpuVo.sellingPrice : '',
          //     fileUrl: list[i].commoditySpuVo ? list[i].commoditySpuVo.fileInfo.fileUrl : '',
          //     commodityType: list[i].commoditySpuVo ? (list[i].commoditySpuVo.commodityType.indexOf('非标询价品') > -1 ? '10' : '') : ''
          //   })
          // }
          showList = list.map(item => {
            item.spuName = item.commoditySpuVo ? item.commoditySpuVo.name : ''
            item.activityPrice = item.commoditySpuVo ? item.commoditySpuVo.minPrice : ''
            item.minPrice = item.commoditySpuVo ? item.commoditySpuVo.minPrice : ''
            item.sellingPrice = item.commoditySpuVo ? item.commoditySpuVo.sellingPrice : ''
            item.fileUrl = item.commoditySpuVo ? item.commoditySpuVo.fileInfo.fileUrl : ''
            if (item.commoditySpuVo) {
              if (item.commoditySpuVo.commodityType.indexOf('非标询价品') > -1) {
                item.commodityType = '10'
              }
            }
            return item
          })
          _this.showGoodlist = _this.showGoodlist.concat(showList)
          console.log(_this.showGoodlist)
          this.lodding = true
        })
        .finally(() => {
          this.$store.commit('setLoadStatus', false)
        })
    },
    // 属性列表展开按钮
    show (index, e) {
      let oEvevt = e
      let selects = document.getElementsByClassName('item-class-select')
      if (oEvevt.target.innerText === this.$t('common.open')) {
        oEvevt.target.innerText = this.$t('common.collapse')
      } else {
        oEvevt.target.innerText = this.$t('common.open')
      }
      selects[index].style.height === 'auto' ? selects[index].style.height = '' : selects[index].style.height = 'auto'
    },
    // 选择属性值
    choose (e, index, subIndex) {
      let oEvevt = e
      if (oEvevt.target.nodeName !== 'SPAN') {
        return false
      }
      this.choosedIndex = subIndex
      this.showGoodlist = []
      this.typeId = this.bestSellersTypes[subIndex].bestSellersTypeId
      this.limit = 24
      this.page = 1
      this.count = 0
      this.pageCount = 0
      this.getBestSellersType()
    },
    // 选择属性值
    clear (index) {
      if (this.choosedIndex === index) {
        this.choosedIndex = -1
        this.typeId = ''
        this.limit = 24
        this.page = 1
        this.showGoodlist = []
        this.count = 0
        this.pageCount = 0
        this.getBestSellersType()
      }
    }
  },
  created () {
    this.init()
    var _this = this
    window.onscroll = function () {
      // 变量scrollTop是滚动条滚动时，距离顶部的距离
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 变量windowHeight是可视区的高度
      var windowHeight = document.documentElement.clientHeight || document.body.clientHeight
      // 变量scrollHeight是滚动条的总高度
      var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
      // 滚动条到底部的条件
      if (scrollHeight - scrollTop - windowHeight < 300 && _this.scroll && _this.lodding) {
        // 写后台加载数据的函数
        console.log(scrollHeight - scrollTop - windowHeight)
        _this.page = _this.page + 1
        _this.getBestSellersType()
      }
    }
  },
  mounted () { },
  components: {
    GoodsList
  }
  // store
}
</script>

<style scoped>
.item-class-spandx {
  background-color: rgb(255, 255, 255);
  padding: 4px 0px 4px 10px;
  border: 1px solid rgb(29, 101, 168);
  color: rgb(29, 101, 168);
  /* margin-top: 1px; */
  font-size: 12px;
}
.iconstyle {
  text-align: center;
  width: 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  background: #1d65a8;
  color: #fff;
  font-size: 12px;
}
/*筛选*/
.item-class-show {
  margin: 15px auto;
  width: 100%;
  background: #ffffff;
}
.item-class-group {
  margin-top: 1px;
}
.item-class-name {
  text-align: right;
  padding-right: 15px;
  /*padding-left: 15px;*/
  line-height: 36px;
  /* color: #666; */
  font-weight: bold;
  background-color: #fff;
}
.item-class-name:first-child {
  line-height: 36px;
}
.item-class-select {
  overflow: hidden;
  /* width: 100%; */
  /* height: 36px; */
}
.item-class-select div {
  /* width: 85px; */
  height: 24px;
  text-align: center;
  color: #005aa0;
  /* line-height: 36px; */
  cursor: pointer;
  float: left;
  /* margin-top: 2px; */
}
.item-class-select div span {
  display: block;
  width: 134px;
  padding: 0px;
  border: 0px;
  /* border-radius: 100px; */
  text-align: center;
  color: #333333;
  cursor: pointer;
  /*line-height: 36px;*/
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 0px;
}
.actions {
  margin: 0 auto;
  line-height: 36px;
  align-items: center;
  font-weight: bold;
}
.actions span:hover {
  cursor: pointer;
}
.m15 {
  margin-top: 15px;
  margin-bottom: 15px;
}
.goods-box {
  display: block;
  width: 100%;
}
.goods-box:after {
  content: "";
  display: block;
  clear: both;
}
/* ---------------商品栏开始------------------- */
.ssimg {
  width: 100%;
  height: 100%;
}
.goods-show-info {
  width: 290px;
  margin-right: 10px;
  margin-top: 10px;
  float: left;
  background: #fff;
  height: 300px;
}
.goods-show-infor {
  margin-right: 0px !important;
}
.goods-show-img {
  cursor: pointer;
  width: 100%;
  text-align: center;
  height: 217px;
}
.goods-show-price {
  margin-top: 6px;
}
.goods-show-detail {
  font-size: 12px;
  margin: 0px 0px;
  padding: 10px;
  height: 80px;
  line-height: 30px;
  border-top: 1px #eee solid;
}
.tags {
  color: #005aa0;
}
.goods-show-num {
  font-size: 12px;
  margin-bottom: 6px;
  color: #009688;
}
.goods-show-num span {
  color: #005aa0;
  font-weight: bold;
}
.goods-show-seller {
  font-size: 12px;
  color: #e4393c;
}
.goods-page {
  width: 100%;
  padding-top: 20px;
  display: flex;
  justify-content: flex-end;
}
/* ---------------商品栏结束------------------- */
/*面包屑*/
.ivu-breadcrumb {
  color: #999;
  font-size: 12px;
}
.ivu-breadcrumb-item-separator {
  margin: 0 3px;
  color: #dcdee2;
}

.item_label {
  float: left;
  margin: 0 0 0 15px;
  font-size: 20px;
  line-height: 50px;
  width: 25%;
}
.item_filter {
  float: right;
  line-height: 50px;
  margin: 0 5px;
  max-width: 70%;
}
.item_filter .item {
  float: left;
  cursor: pointer;
  line-height: 50px;
  margin: 0 5px;
}
.item_filter .item:hover {
  color: #409eff;
  text-decoration: underline;
}
.productHref {
  cursor: pointer;
  color: #333;
}
/* 面包屑最后一个取消销售 */
.integralBreadcrumb div:nth-last-child(1) {
  cursor: auto;
}
</style>
